import { useState, useEffect, useRef } from "react";
import "./carousel.css";
import walkthrough1 from "../../Assets/icon/login-walkthough1.png";
import walkthrough2 from "../../Assets/icon/login-walkthough2.png";
import walkthrough3 from "../../Assets/icon/login-walkthough3.png";

const Carousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const pauseTimeoutRef = useRef(null);
  const intervalRef = useRef(null);

  const images = [walkthrough1, walkthrough2, walkthrough3];

  useEffect(() => {
    if (isPaused) return;

    // 8 seconds dwell time per image
    intervalRef.current = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 8000);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [isPaused, images.length]);

  // Pause on interaction handlers
  const handleUserInteraction = () => {
    setIsPaused(true);
    
    // Clear existing timeout
    if (pauseTimeoutRef.current) {
      clearTimeout(pauseTimeoutRef.current);
    }
    
    // Resume after 8 seconds of no interaction
    pauseTimeoutRef.current = setTimeout(() => {
      setIsPaused(false);
    }, 8000);
  };

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (pauseTimeoutRef.current) {
        clearTimeout(pauseTimeoutRef.current);
      }
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  const getTransform = (index) => {
    if (index === currentIndex) return 'translateX(0)';
    if (index === (currentIndex + 1) % images.length) return 'translateX(100%)';
    return 'translateX(-100%)';
  };

  return (
    <div 
      className="carousel-container"
      onClick={handleUserInteraction}
      onFocus={handleUserInteraction}
    >
      <div className="carousel-content">
        {images.map((image, index) => (
          <div
            key={index}
            className="carousel-item"
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              opacity: index === currentIndex ? 1 : 0,
              transform: getTransform(index),
              transition: 'opacity 1100ms ease-in-out, transform 1100ms ease-in-out',
              pointerEvents: index === currentIndex ? 'auto' : 'none'
            }}
          >
            <img 
              src={image} 
              alt={`Login walkthrough ${index + 1}`}
              className="carousel-image"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Carousel;